var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-icon white text-xs-center"},[_c('img',{attrs:{"src":_vm.card.icon,"alt":_vm.card.alt,"height":"42"}}),_vm._v(" "),_c('p',{staticClass:"card-icon-text primary--text"},[_vm._v("\n\t\t"+_vm._s(_vm.card.text)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c9b8b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/card-icon.vue
// module id = 425
// module chunks = 0